module.exports = __webpack_public_path__ + "static/media/notifs.6d869392.svg";